<script>
export default {
  components: {},
  props: {
    icon: {
      type: String,
      required: false,
      default: null
    },
    padHorizontal: {
      type: Boolean,
      required: false
    }
  },
  data() {
    return {}
  },
  computed: {},
  mounted() {},
  methods: {}
}
</script>

<template>
  <div :class="['base-page-heading', { 'pad-horizontal': padHorizontal }]">
    <img class="icon-base-page-heading" :src="icon" v-if="icon"/>
    <slot></slot>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.base-page-heading {
  display: flex;
  margin-bottom: 2rem;

  &.pad-horizontal {
    padding: 0 2.5rem;
  }

  .icon-base-page-heading {
    height: 3.7rem;
    margin-right: 1.35rem;
    width: 2.8rem;
  }

  .base-page-heading-title {
    margin-bottom: 0;

    small {
      color: $color-gray;
      display: block;
      font-size: 1.4rem;
      font-weight: 800;
      line-height: 2;
    }
  }
}
</style>
